import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export var LOCALES_KEYS;

(function (LOCALES_KEYS) {
  LOCALES_KEYS["EN_US"] = "en-US";
  LOCALES_KEYS["ZH_CN"] = "zh-CN";
})(LOCALES_KEYS || (LOCALES_KEYS = {}));

export var SUPPOER_LOCALES = [{
  name: 'English',
  value: LOCALES_KEYS.EN_US
}, {
  name: '简体中文',
  value: LOCALES_KEYS.ZH_CN
}];
export function getLocaleLoader(locale) {
  switch (locale) {
    case LOCALES_KEYS.ZH_CN:
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          var loc, antdLoc;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return import(
                  /* webpackChunkName: "zh-CN" */
                  './zh_CN.json').then(m => m.default);

                case 2:
                  loc = _context.sent;
                  _context.next = 5;
                  return import(
                  /* webpackChunkName: "antd-zh-CN" */
                  'antd/lib/locale-provider/zh_CN').then(m => m.default);

                case 5:
                  antdLoc = _context.sent;
                  resolve({
                    localeData: loc,
                    antdLocaleData: antdLoc
                  });

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());

    default:
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {
          var loc, antdLoc;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return import(
                  /* webpackChunkName: "en-US" */
                  './en_US.json').then(m => m.default);

                case 2:
                  loc = _context2.sent;
                  _context2.next = 5;
                  return import(
                  /* webpackChunkName: "antd-en-US" */
                  'antd/lib/locale-provider/en_US').then(m => m.default);

                case 5:
                  antdLoc = _context2.sent;
                  resolve({
                    localeData: loc,
                    antdLocaleData: antdLoc
                  });

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
  }
}